<template>
    <div>
        <div class="flex items-center gap-4 lg:gap-8">
            <a
                v-for="tab in tabs"
                :key="tab.key"
                :href="tab.url"
                :class="{
                    'border-b-primary text-primary': selectedTabKey === tab.key,
                    'border-transparent text-gray-700':
                        selectedTabKey !== tab.key,
                }"
                class="cursor-pointer py-3 font-medium border-b-2 flex items-center gap-1"
            >
                <span v-if="tab.iconName">
                    <Icon
                        :name="tab.iconName"
                        :class="tab.iconClass"
                    />
                </span>
                <span>
                    {{ tab.title }}
                </span>
            </a>
        </div>
        <div class="border-b border-b-gray-200 -mt-px"></div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Icon from '@/Shared/Component/Icon.vue'

    export interface TabItemInterface {
        key: string
        title: string
        url: string
        iconName: string | null
        iconClass: string | null
    }

    const props = defineProps({
        tabs: {
            type: Array as PropType<TabItemInterface[]>,
            required: true,
        },
        selectedTabKey: {
            type: String,
            required: true,
        },
    })
</script>
